import React, { useEffect } from "react";

import { Container, Col, Row } from "react-bootstrap";

import { cardsContent } from "../../../utility/content/ContactPage";

import scrollToTop from "../../../libs/scrollToTop";

import {
  Title,
  SubTitle,
  Caption,
  CardContent,
  StyledSection,
} from "./styledContactPage";
import { StyledMark } from "../../../style/base/styledPublicPages";

const ContactPageComponent = () => {
  useEffect(() => {
    document.title = "تماس با ما";
    scrollToTop();
  }, []);
  
  return (
    <StyledSection className="mx-auto">
      <Container>
        <h1 className="text-center mt-5 pt-5">
          <StyledMark>تماس با ما </StyledMark>
        </h1>
        <Row>
          {cardsContent.map((item) => (
            <Col xs={12} lg={4} className="mt-4 mt-lg-5" key={item.id}>
              {item.caption ? (
                <CardContent className="mx-auto p-3 d-flex flex-column justify-content-around align-items-start">
                  <img src={item.image} alt={`تصویر ${item.title}`} />
                  <Title className="d-flex mt-4">{item.title}</Title>
                  <SubTitle className="mt-4 mb-4">{item.subTitle}</SubTitle>
                  {item.caption?.map((item, index) => (
                    <span key={index} className="d-flex flex-row align-items-start">
                      <i className="m-2">{item.icon}</i>
                      <Caption className="m-2">{item?.text}</Caption>
                    </span>
                  ))}
                </CardContent>
              ) : (
                <>
                  <CardContent className="mx-auto p-3">
                    <img
                      src={item.image}
                      alt={`تصویر ${item.title}`}
                      style={{ width: "44px" }}
                    />
                    <Title className="d-flex mt-4">{item.title}</Title>
                    <SubTitle className="mt-4 mb-4">{item.subTitle}</SubTitle>
                    <span className="d-flex flex-row align-items-start mx-auto mb-4">
                      {item.socialData?.map((item, index) => (
                        <Col
                          className="icon-background bg-secondary rounded-circle p-1 m-3"
                          key={index}
                        >
                          <a
                            href={item.url}
                            target="_blank"
                            rel="noreferrer"
                            className="m-2"
                          >
                            {item.icon}
                          </a>
                        </Col>
                      ))}
                    </span>
                  </CardContent>
                </>
              )}
            </Col>
          ))}
        </Row>
      </Container>
    </StyledSection>
  );
};

export default ContactPageComponent;
